/**
 * The rendered preview runs inside a sandboxed `srcdoc` iframe, so its scrollbars
 * belong to that document and no parent stylesheet — or the `customScrollbar` mixin —
 * can reach them. This injects the DS scrollbar into the preview document instead, so
 * the rendered view matches the code view and the rest of the app.
 *
 * Values are literals rather than tokens on purpose: the iframe document does not load
 * the ui-lib stylesheet, so `var(--interactive-bg-secondary-press)` would resolve to
 * nothing there. They mirror `customScrollbar` in `@foundever/ui-lib/mixins.scss`:
 * 4px track, pill thumb on `--interactive-bg-secondary-press`, `--icon-secondary` on
 * hover/active. Keep them in step if the DS scrollbar changes.
 *
 * Preview only — the published page is served from `content` untouched, so real
 * visitors still get whatever scrollbar the page itself defines. This is injected
 * ahead of the page's own styles so a page that deliberately styles its scrollbar
 * still wins.
 */
export function previewScrollbarStyleSource(): string {
  return `::-webkit-scrollbar{width:4px;height:4px}
::-webkit-scrollbar:hover{width:4px;height:4px}
::-webkit-scrollbar-track{background:transparent}
::-webkit-scrollbar-thumb{background-color:#aaaab6;border-radius:9999px}
::-webkit-scrollbar-thumb:hover,::-webkit-scrollbar-thumb:active{background-color:#57576b}
@supports not selector(::-webkit-scrollbar){html{scrollbar-color:#aaaab6 transparent;scrollbar-width:thin}}`
}
